import React from "react";
import Particles from "../../Background/Particles";
import { Fade } from "react-awesome-reveal";
import Seo from "../../components/Seo";

const Contact = () => {
    return (
      <>
        <Seo
          title="Contact — Efwan Rizaldi"
          description="Get in touch with Efwan Rizaldi for software engineering opportunities, collaborations, or freelance work."
          path="/contact"
        />
        <section
            id="contact"
            className="min-h-screen flex-col items-center justify-center py-24 px-6 overflow-hidden text-white"
        >
            {/* === Particle Background === */}
            <div className="absolute top-0 left-0 w-full h-full">
                <Particles
                    particleColors={["#ffffff"]}
                    particleCount={60}
                    particleSpread={25}
                    speed={0.05}
                    particleBaseSize={32}
                    alphaParticles={false}
                    disableRotation={true}
                    pixelRatio={1}
                />
            </div>

            {/* === Decorative Glow === */}
            <div className="absolute inset-0 -z-10 bg-gradient-to-tr from-orange-500/10 via-transparent to-cyan-400/10 blur-3xl"></div>

            {/* === Title === */}
            <Fade direction="up" duration={1000} triggerOnce>
                <h1 className="text-5xl md:text-7xl font-extrabold bg-gradient-to-r from-orange-500 to-cyan-400 text-transparent bg-clip-text mb-8 tracking-tight text-center drop-shadow-[0_0_25px_rgba(0,255,200,0.3)]">
                    Contact Us
                </h1>
                <p className="text-gray-300 text-lg md:text-xl text-center max-w-2xl mx-auto mb-20 leading-relaxed">
                    We are ready to help you find the right place to call home.
                    Please reach out through the contact details below.
                </p>
            </Fade>

            {/* === Contact Cards === */}
            <Fade direction="up" duration={1200} triggerOnce>
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-10 w-full max-w-6xxl">
                    {[
                        {
                            icon: "fa-map-marker-alt",
                            title: "Address",
                            desc: "Jln, Abdul Gani, RT 03 / RW 04, Desa Karanggan, Kec. Gunung Putri - Bogor 16961",
                        },
                        {
                            icon: "fa-phone",
                            title: "Phone",
                            desc: (
                                <a href="/about" className="text-orange-500 hover:text-cyan-300 transition">
                                    Click here
                                </a>
                            ),
                        },
                        {
                            icon: "fa-envelope",
                            title: "Email",
                            desc: (
                                <a
                                    href="mailto:efwanrizaldi@gmail.com"
                                    className="text-orange-500 hover:text-cyan-300 transition"
                                >
                                    efwanrizaldi@gmail.com
                                </a>
                            ),
                        },
                    ].map((item, i) => (
                        <div
                            key={i}
                            className="relative group bg-white/10 backdrop-blur-xl rounded-3xl p-10 text-center border border-white/20 
              shadow-[0_0_25px_rgba(0,255,200,0.1)] hover:shadow-[0_0_35px_rgba(0,255,200,0.3)]
              transition-all duration-500 hover:-translate-y-2"
                        >
                            {/* Glow effect */}
                            <div className="absolute inset-0 rounded-3xl bg-gradient-to-b from-orange-500/10 to-transparent opacity-0 group-hover:opacity-100 blur-xl transition"></div>

                            <div className="relative z-10">
                                <div className="flex justify-center mb-5">
                                    <span
                                        className={`fas ${item.icon} text-5xl text-orange-500 group-hover:text-cyan-300 transition`}
                                    ></span>
                                </div>
                                <h3 className="text-2xl font-bold text-orange-500 mb-3 tracking-wide">
                                    {item.title}
                                </h3>
                                <p className="text-gray-300 text-base leading-relaxed">{item.desc}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </Fade>

            {/* === Map Section === */}
            <Fade direction="up" duration={1500} triggerOnce>
                <div className="w-full max-w-6xxl px-8 mt-24">
                    <div className="relative rounded-3xl overflow-hidden border border-white/20 shadow-[0_0_40px_rgba(0,255,200,0.2)] hover:shadow-[0_0_60px_rgba(0,255,200,0.3)] transition-all duration-500">
                        <iframe
                            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d993.5621095135226!2d106.8947919!3d-6.452662199999999!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2e69eba2c2b6502d%3A0x6de86738bcf8563c!2sADZANI%20CELL!5e0!3m2!1sid!2sid!4v1729253745962!5m2!1sid!2sid"
                            width="100%"
                            height="450"
                            className="w-full h-[400px] rounded-3xl overflow-hidden shadow-[0_0_40px_rgba(0,255,200,0.2)] hover:shadow-[0_0_60px_rgba(0,255,200,0.3)] transition-all duration-500"
                            style={{ border: 0 }}
                            allowFullScreen
                            loading="lazy"
                            referrerPolicy="no-referrer-when-downgrade"
                            title="Google Maps - ADZANI CELL"
                        ></iframe>
                        <div className="absolute inset-0 pointer-events-none bg-gradient-to-t from-black/40 via-transparent to-black/20"></div>
                    </div>
                </div>
            </Fade>
        </section>
      </>
    );
};

export default Contact;
